import {matchPath} from "react-router-dom-v5-compat";

const SUBMIT_ONLY_PATHS = [
    // Specific Learner Activities
    "/profile/me/khanmigo/activities/activity-learner-whats-next",
];

/**
 * Determines if the Assignment is submit only for given path.
 */
export const isSubmitOnlyAssignment = (path: string): boolean =>
    SUBMIT_ONLY_PATHS.some((submitOnlyPath) => matchPath(submitOnlyPath, path));
